import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import api from "APP_ROOT/api";
import { useCurrentUser } from "APP_ROOT/hooks";
import LocationPanel from "MODULES/Admin/Integrations/LocationPanel";
import { connect } from "react-redux";
import { subscribe } from "../sessionChannel";

function Integrations({ subscribeToLocations }) {
  const [qbUrl, setQbUrl] = useState(null);
  const locations = useCurrentUser().locations;

  useEffect(() => {
    api.integrations.quickbooks.oauth().then(resp => {
      subscribeToLocations();
      setQbUrl(resp.data.redirect_uri);

      return function cleanup() {};
    });
  }, []);

  if (!qbUrl) return null;

  return (
    <div>
      <h2>Integrations</h2>
      <div className="row">
        {locations.map(l => (
          <LocationPanel location={l} locations={locations} />
        ))}
      </div>
    </div>
  );
}

export default withRouter(
  connect(undefined, dispatch => ({
    subscribeToLocations: () => dispatch(subscribe())
  }))(Integrations)
);



// WEBPACK FOOTER //
// ./app/modules/Admin/Integrations/Integrations.jsx